import { cn } from '../utils/utils';

/**
 * The primary heading of a screen, with its supporting line.
 *
 * Two elements, but worth a component because the `<h1>` here was written out
 * twice character-for-character - once for the auth forms and once inside the
 * status card - and only one of the two copies carried the warning below.
 *
 * `gap` exists so both callers keep the spacing they had: the form heading sits
 * tight against the fields under it, the status heading sits under a medallion
 * on a looser rhythm.
 */
export function PageHeading({
  title,
  subtitle,
  gap = 'tight',
  className,
}: {
  title: string;
  subtitle?: React.ReactNode;
  gap?: 'tight' | 'loose';
  className?: string;
}) {
  return (
    <div
      className={cn(gap === 'loose' ? 'space-y-3' : 'space-y-1.5', className)}
    >
      {/* Plain concatenation, never cn(): tailwind-merge treats this repo's
          custom fontSize keys as colours, so cn('text-title text-foreground')
          drops the size and renders at the inherited 16/400. */}
      <h1 className='text-title text-foreground'>{title}</h1>
      {subtitle && (
        <p className='text-body text-muted-foreground'>{subtitle}</p>
      )}
    </div>
  );
}
